import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api, formatMoney } from '@/lib/api';
import { PublicHeader } from '@/components/marketplace/PublicHeader';

import { Button } from '@/components/ui/button';
import { CheckCircle2, Loader2 } from 'lucide-react';

export default function OrderSuccessPage() {
    const [params] = useSearchParams();
    const sid = params.get('session_id');
    const [status, setStatus] = useState({ payment_status: 'pending' });
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        if (!sid) return;
        let cancelled = false;
        let att = 0;
        const poll = async () => {
            if (cancelled) return;
            try {
                const { data } = await api.get(`/checkout/status/${sid}`);
                if (cancelled) return;
                setStatus(data);
                setAttempts(att);
                if (data.payment_status === 'paid' || data.status === 'expired' || att >= 10) return;
                att += 1;
                setTimeout(poll, 2000);
            } catch {
                att += 1;
                if (att < 5) setTimeout(poll, 2000);
            }
        };
        poll();
        return () => { cancelled = true; };
    }, [sid]);

    return (
        <div className="min-h-screen flex flex-col">
            <PublicHeader />
            <main className="flex-1 max-w-2xl mx-auto w-full px-4 sm:px-6 lg:px-10 py-14 text-center">
                {status.payment_status === 'paid' ? (
                    <>
                        <CheckCircle2 className="h-16 w-16 text-[hsl(var(--ok-success))] mx-auto" />
                        <h1 className="mt-4 text-3xl font-semibold tracking-tight">¡Pago confirmado!</h1>
                        <p className="mt-2 text-muted-foreground">Total: <span className="money font-semibold">{formatMoney(status.amount_total || 0)}</span></p>
                        <p className="mt-4 text-sm text-muted-foreground">Tu pago está en escrow. Se liberará al vendedor cuando confirmes la recepción del producto.</p>
                        <div className="mt-6 flex justify-center gap-3">
                            <Button asChild><Link to="/dashboard/purchases">Ver mis compras</Link></Button>
                            <Button variant="outline" asChild><Link to="/">Volver al inicio</Link></Button>
                        </div>
                    </>
                ) : (
                    <>
                        <Loader2 className="h-10 w-10 animate-spin text-[hsl(var(--primary))] mx-auto" />
                        <h1 className="mt-4 text-2xl font-semibold tracking-tight">Confirmando tu pago…</h1>
                        <p className="mt-2 text-sm text-muted-foreground">Intento {attempts + 1} de 10. No cierres esta ventana.</p>
                    </>
                )}
            </main>
            
        </div>
    );
}
